<template>
    <div class="addList">
        <el-row class="row-bg">
            <el-col :span="12" style="text-align: left;">
                <el-button size="mini" :disabled="IsSelected" @click="IsSelectedAllFun">全部</el-button>
                <el-button size="mini" :disabled="!IsSelected" @click="IsSelectedFun">已选择</el-button>
            </el-col>
            <el-col :span="12" style="text-align: right;">
                <el-button size="mini" type="primary" @click="handleSearch">查询</el-button>
                <el-button size="mini" type="success" @click="handleReset">重置</el-button>
            </el-col>
        </el-row>
        <el-table
            :stripe="true"
            :data="tableData"
            style="width: 100%;"
            v-loading="listLoading"
            @select="onTableSelect"
            @select-all="onTableSelect"
            border
            ref="multipleTable"
            >
            <el-table-column type="selection" width="40"></el-table-column>
            <!-- eslint-disable  -->
            <el-table-column label="企业ID">
                <el-table-column show-overflow-tooltip width="190">
                    <template slot="header" slot-scope="scope">
                        <el-input size="mini" v-model="form.CompanyId" placeholder="输入企业ID"/>
                    </template>
                    <template slot-scope="scope">
                        <span>{{scope.row.CompanyId || '--'}}</span>
                    </template>
                </el-table-column>
            </el-table-column>
            <el-table-column label="企业名称" >
                <el-table-column show-overflow-tooltip width="190">
                    <template slot="header" slot-scope="scope">
                        <el-input size="mini" v-model="form.CompanyName" placeholder="输入企业名称"/>
                    </template>
                    <template slot-scope="scope">
                        <span>{{scope.row.CompanyName || '--'}}</span>
                    </template>
                </el-table-column>
            </el-table-column>
            <el-table-column label="联系人" >
                <el-table-column show-overflow-tooltip width="190">
                    <template slot="header" slot-scope="scope">
                        <el-input size="mini" v-model="form.LinkMan" placeholder="输入联系人姓名"/>
                    </template>
                    <template slot-scope="scope">
                        <span>{{scope.row.LinkMan || '--'}}</span>
                    </template>
                </el-table-column>
            </el-table-column>
            <el-table-column label="所在地区" width="190">
                <el-table-column show-overflow-tooltip>
                    <template slot="header" slot-scope="scope">
                        <el-input size="mini" v-model="region" placeholder="请选择所在地"  @click.native="isRegionShow"/>
                    </template>
                    <template slot-scope="scope">
                        <span v-if="scope.row.ProvinceName">{{scope.row.ProvinceName}}{{scope.row.CityName}}{{scope.row.XianName}}</span>
                        <span v-else>--</span>
                    </template>
                </el-table-column>
            </el-table-column>
            <el-table-column label="企业角色">
                <el-table-column show-overflow-tooltip width="183">
                    <template slot="header" slot-scope="scope">
                        <el-select size="mini" v-model="form.RoleCode" placeholder="请选择企业角色" style="width: 100%;">
                            <el-option :value="item.RolesCode" :label="item.RolesName" v-for="(item, index) in rolesList" :key="index"></el-option>
                        </el-select>
                    </template>
                    <template slot-scope="scope">
                        <span>{{scope.row.RoleName || '--'}}</span>
                    </template>
                </el-table-column>
            </el-table-column>
            <el-table-column label="联系方式">
                <el-table-column show-overflow-tooltip width="190">
                    <template slot="header" slot-scope="scope">
                        <el-input size="mini" v-model="form.HandSet" placeholder="输入联系方式"/>
                    </template>
                    <template slot-scope="scope">
                        <span>{{scope.row.HandSet || '--'}}</span>
                    </template>
                </el-table-column>
            </el-table-column>
            <el-table-column label="注册时间">
                <el-table-column show-overflow-tooltip width="245">
                    <template slot="header" slot-scope="scope">
                        <el-date-picker
                            size="mini"
                            v-model="form.CreateTime"
                            type="daterange"
                            format="yyyy-MM-dd"
                            value-format="yyyy-MM-dd"
                            range-separator="—"
                            start-placeholder="开始日期"
                            end-placeholder="结束日期"
                            style="width: 100%;"
                        ></el-date-picker>
                    </template>
                    <template slot-scope="scope">
                        <span>{{scope.row.CreateTime || '--'}}</span>
                    </template>
                </el-table-column>
            </el-table-column>
        </el-table>
        <div style="margin: 10px;overflow: hidden">
            <div style="float: right;" v-show="tableData.length">
                <el-pagination
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="form.PageIndex"
                    :page-sizes="[10, 20, 50, 100, 200]"
                    :page-size="form.PageSize"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="total">
                </el-pagination>
            </div>
        </div>
        <el-dialog 
            :visible.sync="regionShow" 
            title="所在地区" 
            width="34%" 
            ref="dialog"
            append-to-body
        >
            <el-form ref="region" label-width="60px" :model="regionForm">
                <el-form-item label="地址：">
                    <el-select 
                        size="medium" 
                        value-key="ID"
                        v-model="regionForm.ProvinceId"
                        placeholder="省"
                        filterable
                        clearable
                        style="width: 30%;margin-right: 10px;"
                        @change="ProvinceIdFun"
                        @clear="clearProvinceIdFun"
                    >
                        <el-option :value="item" :label="item.name" v-for="(item, index) in ProvinceIdList" :key="index"></el-option>
                    </el-select>
                    <el-select 
                        size="medium" 
                        value-key="ID" 
                        v-model="regionForm.CityId" 
                        placeholder="市" 
                        filterable 
                        clearable 
                        style="width: 30%;margin-right: 10px;" 
                        @change="CityIdFun"
                        @clear="clearCityIdFun"
                    >
                        <el-option :value="item" :label="item.name" v-for="(item, index) in CityIdList" :key="index"></el-option>
                    </el-select>
                    <el-select 
                        size="medium" 
                        value-key="ID" 
                        v-model="regionForm.XianId" 
                        placeholder="区/县" 
                        filterable 
                        clearable 
                        style="width: 30%;" 
                        @clear="clearXianIdFun"
                    >
                        <el-option :value="item" :label="item.name" v-for="(item, index) in XianIdList" :key="index"></el-option>
                    </el-select>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button type="primary" @click="submitAddressFun">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>
<script>
import { 
  getStorageToken,
} from '@/utils/store'
import {
    enterpriseList,          //企业列表
    getAreaDataByParent,        //获取地址
    addCouponAccount,           //添加用户
} from "@/service/coupons";
import {
    listRoles,              //用户角色
} from '@/service/area'
  export default {
    data() {
        return {
            listLoading: false,
            IsSelected: true,
            form: {
                PageIndex: 0,
                PageSize: 13,

                CompanyId: '',      //企业ID
                CompanyName: '',    //企业名称
                LinkMan: '',        //联系人
                HandSet: '',        //联系方式
                RoleCode: '',       //企业角色
                CreateTime: [],     //创建时间
                IsSelected: false,

            },
            regionForm: {
                ProvinceId: '', //省
                CityId: '', //市
                XianId: '', //区
            },
            ProvinceIdList: [],
            CityIdList: [],
            XianIdList: [],
            searchData:{},
            oraginForm:{},
            total: 0,                       //总条数

            region:'',      //地区
            regionShow: false,

            tableData:[],
            rolesList: [],

            selectUserMap: {},
            parentFrom: ''
        }
    },
    activated(){
    },
    created() {
        this.oraginForm = JSON.parse(JSON.stringify(this.form))
        this.tableData = [];
        this.listRolesFun();
    },
    computed: {
    },
    mounted() {
    },
    methods: {
        //获取用户身份
        listRolesFun(){
            let data = {
                UserType: 2,
                platform: "pcweb"
            }
            listRoles(data).then(res=>{
                this.rolesList = res.Data

            })
        },
        //全部
        IsSelectedAllFun(){
            this.IsSelected = true
            this.form.IsSelected = false
            this.handleSearch();
        },
        //点击已选择
        IsSelectedFun(){
            this.IsSelected = false
            this.form.IsSelected = true
            this.selectUserMap = {};
            this.handleSearch();
        },
        //关于地址
        isRegionShow(){
            this.regionShow = true
            this.getAreaDataByParentFun(0,1)
        },
        ProvinceIdFun(){
            this.getAreaDataByParentFun(this.regionForm.ProvinceId.ID,2)
            this.clearCityIdFun()
        },
        CityIdFun(){
            this.getAreaDataByParentFun(this.regionForm.CityId.ID,3)
            this.clearXianIdFun()
        },
        clearProvinceIdFun(){
            this.regionForm.ProvinceId = {ID : '',name: ''}
            this.regionForm.CityId = {ID : '',name: ''}
            this.regionForm.XianId = {ID : '',name: ''}
        },
        clearCityIdFun(){
            this.regionForm.CityId = {ID : '',name: ''}
            this.regionForm.XianId = {ID : '',name: ''}
        },
        clearXianIdFun(){
            this.regionForm.XianId = {ID : '',name: ''}
        },
        submitAddressFun(){
            this.region = this.regionForm.ProvinceId.name + this.regionForm.CityId.name + this.regionForm.XianId.name
            this.regionShow = false
        },
        //获取地址
        async getAreaDataByParentFun(id,hier){
            let data = {
                parentID: id,
                platform: 'pcweb'
            }
            let res = await getAreaDataByParent(data)
            switch(hier){
                case 1:
                    this.ProvinceIdList = res.Data
                    // console.log('省')
                    break;
                case 2:
                    this.CityIdList = res.Data
                    // console.log('市')
                    break;
                default:
                    this.XianIdList = res.Data
                    // console.log('县')
            }
        },
        //END
        //渲染列表
        handleSearch(parentFrom) {
            if(parentFrom) {
                this.parentFrom = parentFrom
            }
            this.searchData = Object.assign({}, this.form)
            this.selectUserMap = {}
            this.handleCurrentChange(1)
        },
        handleCurrentChange(val) {
            if (this.listLoading) return
            this.form.PageIndex = val
            this.searchData.PageIndex = val
            this.GetEnterpriseList()
        },
        //翻页
        handleSizeChange(val) {
        if (this.listLoading) return
            this.form.PageIndex = 1
            this.form.PageSize = val
            this.searchData.PageIndex = 1
            this.searchData.PageSize = val
            this.GetEnterpriseList()
        },
        async GetEnterpriseList(){
            this.listLoading = true
            let data = JSON.parse(JSON.stringify(this.searchData))
            !data.CompanyId && delete data.CompanyId
            !data.CompanyName && delete data.CompanyName
            !data.LinkMan && delete data.LinkMan
            data.RoleCode == '' && delete data.RoleCode
            !data.HandSet && delete data.HandSet
            data.ProvinceId = this.regionForm.ProvinceId.ID
            data.CityId = this.regionForm.CityId.ID
            data.XianId = this.regionForm.XianId.ID
            !data.ProvinceId && data.ProvinceId
            !data.CityId && data.CityId
            !data.XianId && data.XianId
            if(data.CreateTime && data.CreateTime.length) {
                data.CreateStartTime = data.CreateTime[0]
                data.CreateEndTime = data.CreateTime[1]
            }
            delete data.CreateTime
            data.Token = getStorageToken()
            data.platform = 'pcweb'
            let res = await enterpriseList(data)
            this.listLoading = false
            if(res.Result != 1) {
                return this.$message.error('获取失败请联系开发人员')
            }
            this.tableData = res.Data.List
            this.total = res.Data.TotalRows
            


            this.$nextTick(() => {
                let historyUser = this.getCrrUsersByNum()
                if (historyUser.length) {
                    historyUser.map(item => {
                        this.$refs.multipleTable.toggleRowSelection(item, true)
                    })
                    return
                }
                let defaultUsers = []
                this.tableData.map(item => {
                    if(this.parentFrom === 'redEnvDraw') {
                        item.IsSelect = false;
                    }else {
                        if (item.IsSelect) {
                            defaultUsers.push(item)
                            this.$refs.multipleTable.toggleRowSelection(item, true)
                        }
                    }
                })
                this.selectUserMap[this.form.PageIndex] = {
                    defaultUsers
                }
            })
        },
        handleReset() {
            this.IsSelected = true;
            this.regionForm = {
                ProvinceId: '', //省
                CityId: '', //市
                XianId: '', //区
            }
            this.region = ''
            this.selectUserMap = {}
            this.form = JSON.parse(JSON.stringify(this.oraginForm))
            this.handleSearch()
        },
        handleSelectionChange(rows) {
            const defaultUsers = this.selectUserMap[this.form.PageIndex].defaultUsers || []
            let cancelUsers = []
            let addUsers = []
            rows.map(item => {
                // 如果记录当前页面用户数据不存在当前选择用户 则为新增
                if (!defaultUsers.some(user => item.CompanyId == user.CompanyId)) {
                    addUsers.push(item)
                }
            })
            defaultUsers.map(item => {
                // 如果新用户数据不存在当前选择用户 则为删除
                if (!rows.some(user => item.CompanyId == user.CompanyId)) {
                    cancelUsers.push(item)
                }
            })
            console.log('新增了用户', addUsers.map(item => item.CompanyId).join(','))
            console.log('删除了用户', cancelUsers.map(item => item.CompanyId).join(','))
            this.selectUserMap[this.form.PageIndex].addUsers = addUsers
            this.selectUserMap[this.form.PageIndex].cancelUsers = cancelUsers
        },
        // 获取之前操作的记录中的数据
        getCrrUsersByNum() {
            if (this.selectUserMap[this.form.PageIndex]) {
                let user = [...(this.selectUserMap[this.form.PageIndex].defaultUsers || [])]
                let addUsers = this.selectUserMap[this.form.PageIndex].addUsers || []
                let cancelUsers = this.selectUserMap[this.form.PageIndex].cancelUsers || []
                let cancelUsersIds = cancelUsers.map(item => item.CompanyId)
                addUsers.map(item => {
                    if (!user.some(user => item.CompanyId == user.CompanyId)) {
                        user.push(item)
                    }
                })
                user = user.filter(item => cancelUsersIds.indexOf(item.CompanyId) == -1)
                let ids = user.map(item => item.CompanyId)
                let newuser = this.tableData.filter(item => ids.indexOf(item.CompanyId) != -1)
                return newuser
            } else {
                return []
            }
        },


        addCouponAccountPersonalFun(parentFrom){
            var allAddUsers = []
            var allCancelUsers = []
            var commonArr = []
            Object.keys(this.selectUserMap).forEach((key) => {
                if(this.selectUserMap[key].addUsers) {
                    this.selectUserMap[key].addUsers.map(item=>{
                        allAddUsers.push(item.CompanyId)
                        console.log(allAddUsers)
                    })
                }
                if(this.selectUserMap[key].cancelUsers) {
                    this.selectUserMap[key].cancelUsers.map(item=>{
                        allCancelUsers.push(item.CompanyId)
                        console.log(allCancelUsers)
                    })
                }
            })
            commonArr = commonArr.concat(allAddUsers, allCancelUsers);
            var data = {
                UserType: 2,
                Token: getStorageToken(),
                AccountIdList: [],
                platform: "pcweb"
            }
            data.AccountIdList = commonArr
            if(!data.AccountIdList.length){
                return this.$message.warning('请选择用户')
            }
            if(parentFrom === 'redEnvDraw') {
                this.$emit('onPersonalSubmit',data)
            }else {
                addCouponAccount(data).then(res=> {
                    if(res.Result != 1) {
                        return this.$message.error(res.Message)
                    }
                    this.$message.success('操作成功！')
                    this.$emit('onPersonalSubmit',res.Data)
                })
            }
        },
        onTableSelect(rows){
            this.handleSelectionChange(rows)
        },
    }
  }
</script>
<style lang="scss">
    .addList {
        .el-row {
            margin-bottom: 20px;
            &:last-child {
                margin-bottom: 0;
            }
        }
        .row-bg {
            padding: 10px 14px;
            background-color: #f9fafc;
        }
    }
    
</style>